import React, { useState, useEffect } from 'react';

function PaymentCountdown({ orderCreatedAt, onExpire }) {
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const EXPIRATION_HOURS = 3;
      const createdAt = new Date(orderCreatedAt);
      const expirationTime = new Date(createdAt.getTime() + EXPIRATION_HOURS * 60 * 60 * 1000);
      const now = new Date();
      const diff = expirationTime - now;

      if (diff <= 0) {
        setIsExpired(true);
        setTimeRemaining(null);
        if (onExpire) onExpire();
        return null;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      return { hours, minutes, seconds, totalSeconds: Math.floor(diff / 1000) };
    };

    // Initial calculation
    const initial = calculateTimeRemaining();
    setTimeRemaining(initial);

    // Update every second
    const interval = setInterval(() => {
      const remaining = calculateTimeRemaining();
      setTimeRemaining(remaining);
    }, 1000);

    return () => clearInterval(interval);
  }, [orderCreatedAt, onExpire]);

  if (isExpired) {
    return (
      <div style={{
        background: '#fee2e2',
        border: '1px solid #fca5a5',
        borderRadius: '8px',
        padding: '12px 16px',
        marginBottom: '16px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '0.85rem',
          fontWeight: 600,
          color: '#dc2626'
        }}>
          Payment time expired - Order will be cancelled
        </div>
      </div>
    );
  }

  if (!timeRemaining) {
    return null;
  }

  const { hours, minutes, seconds, totalSeconds } = timeRemaining;
  const totalDuration = 3 * 60 * 60; // 3 hours in seconds
  const percentageRemaining = (totalSeconds / totalDuration) * 100;

  // Use website green theme
  const isUrgent = percentageRemaining < 25;

  return (
    <div style={{
      background: isUrgent ? '#fef3c7' : '#f0f7f1',
      border: `1px solid ${isUrgent ? '#fcd34d' : '#d1fae5'}`,
      borderRadius: '8px',
      padding: '12px 16px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px'
    }}>
      <div style={{
        fontSize: '0.8rem',
        fontWeight: 600,
        color: isUrgent ? '#92400e' : '#15803d',
        flex: 1
      }}>
        Complete payment within:
      </div>
      
      <div style={{
        display: 'flex',
        gap: '6px',
        alignItems: 'center'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '6px',
          padding: '6px 10px',
          minWidth: '42px',
          textAlign: 'center',
          border: `1px solid ${isUrgent ? '#fcd34d' : '#bbf7d0'}`
        }}>
          <div style={{
            fontSize: '1rem',
            fontWeight: 700,
            color: isUrgent ? '#92400e' : '#15803d',
            lineHeight: 1
          }}>
            {String(hours).padStart(2, '0')}
          </div>
        </div>
        <span style={{ color: isUrgent ? '#92400e' : '#15803d', fontWeight: 700 }}>:</span>
        <div style={{
          background: 'white',
          borderRadius: '6px',
          padding: '6px 10px',
          minWidth: '42px',
          textAlign: 'center',
          border: `1px solid ${isUrgent ? '#fcd34d' : '#bbf7d0'}`
        }}>
          <div style={{
            fontSize: '1rem',
            fontWeight: 700,
            color: isUrgent ? '#92400e' : '#15803d',
            lineHeight: 1
          }}>
            {String(minutes).padStart(2, '0')}
          </div>
        </div>
        <span style={{ color: isUrgent ? '#92400e' : '#15803d', fontWeight: 700 }}>:</span>
        <div style={{
          background: 'white',
          borderRadius: '6px',
          padding: '6px 10px',
          minWidth: '42px',
          textAlign: 'center',
          border: `1px solid ${isUrgent ? '#fcd34d' : '#bbf7d0'}`
        }}>
          <div style={{
            fontSize: '1rem',
            fontWeight: 700,
            color: isUrgent ? '#92400e' : '#15803d',
            lineHeight: 1
          }}>
            {String(seconds).padStart(2, '0')}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCountdown;
